module.exports = __webpack_public_path__ + "static/media/pabloSextoEslogan.c8cbc619.jpeg";